import React from 'react'
import FriendButtonListEntry from './FriendButtonListEntry';
import { v4 as uuidv4 } from 'uuid'; 
export default function FriendButtonList({list,oym,dropBreadcrumb,authenticated}) {
    let objectList=list.map(friend => oym.objectRef(friend));
    objectList.sort(oym.compareFriend);
    return (
        objectList.map(friend => {
            return <FriendButtonListEntry key={uuidv4()} friend={friend} oym={oym} dropBreadcrumb={dropBreadcrumb} authenticated={authenticated}/>
        })    
    )
}
